import axios from "axios";

export const getReporteVisitasExcel = async (fecha_inicio, fecha_fin, excluir_no_visita = false) => {
  const response = await axios.get('reporteVisitas/excel', {
    params: { fecha_inicio, fecha_fin, excluir_no_visita },
    responseType: 'blob',
    headers: {
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
  return response.data;
};
